import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-shared-drawer',
  templateUrl: './dynamic-drawer.component.html',
  styleUrls: ['./dynamic-drawer.component.scss']
})
export class AppSharedDrawerComponent {
  @Input() isOpen: boolean = false;

  @Input() title!: string;

  @Input() subtitle?: string;

  @Input() className: string = "";

  @Input() contentClassName: string = "";

  @Output() onClose = new EventEmitter();

	constructor(
	) {}

	ngOnInit() {
	}

	ngOnDestroy() {
	}

  public closeDrawer() {
		this.onClose.emit();
  }
}